import { render } from "./CodeBlock.vue?vue&type=template&id=1b5513e4&scoped=true"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"

import "./CodeBlock.vue?vue&type=style&index=0&id=1b5513e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5513e4"]])

export default __exports__